import PropTypes from 'prop-types'
import classNames from 'classnames'

import classes from './OrganizationChips.module.scss'

const OrganizationChips = ({ organizations, emptyLabel }) => {
  if (!organizations?.length) {
    return <span className={classes.empty}>{emptyLabel}</span>
  }

  return (
    <div className={classNames(classes.chips, 'd-flex flex-wrap')}>
      {organizations.map(organization => (
        <span key={organization.id} className={classNames(classes.chip, 'd-inline-flex align-items-center')}>
          <i className='fa fa-users' aria-hidden='true' />
          {organization.name}
        </span>
      ))}
    </div>
  )
}

OrganizationChips.propTypes = {
  organizations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })),
  emptyLabel: PropTypes.string.isRequired,
}

export default OrganizationChips
